// Import location-specific images
import srinagarImages from "../srinagar/index.js";
import baramullaImages from "../baramulla/index.js";
import fallbackImages from "../fallback/index.js";
import jammuImages from "../jammu/index.js";

// Organize images by location
export const galleryImages = {
  srinagar: srinagarImages,
  baramulla: baramullaImages,
  jammu: jammuImages,
  // Default images (shown when no location is selected or for fallback)
  // Use the first available location's images as fallback
  default: fallbackImages,
};

// Helper function to get images for a specific location
export const getImagesForLocation = (location) => {
  if (!location) {
    return galleryImages.default;
  }

  const locationImages = galleryImages[location];
  if (!locationImages || locationImages.length === 0) {
    console.warn(
      `No images found for location: ${location}, using default images`
    );
    return galleryImages.default;
  }

  return locationImages;
};

// Helper function to get all images
export const getAllImages = () => {
  return galleryImages.default;
};
